import Link from 'next/link'

interface IProps {
  link: boolean
  href?: string
  target?: boolean
  buttonType: string
  className?: string
  buttonText: string
  children?: React.ReactNode
}

const CMButton = (props: IProps) => {
  return props.link === true && props.href ? (
    <div
      className={`cursor-pointer rounded-[5px] flex items-center min-w-[96pxpx] focus:outline-none ${props?.buttonType === 'reportIndividualButton'
          ? ' py-[2px] px-[5px] bg-transparent leading-[20.8571px]'
          : ` justify-center py-[0px] px-[0px] bg-feYellow m-0 border-[3px] border-solid border-feYellow  h-[30px] max-[1200px]:w-[135px] max-[1200px]:h-[30px] hover:bg-transparent hover:text-feYellow text-black ${props?.buttonType === 'footerDonateButton'
            ? 'w-[147px] h-[48.72px] rounded-[8px] shadow-[0px 4px 4px rgba(0, 0, 0, 0.25)] text-[24px] w-[147px]'
            : 'w-[96px]'
          }`
        }`}
    >
      <Link href={props.href} target={props.target ? '_blank' : '_self'} className="text-inherit">
        <div
          className={`${props?.className === 'donate'
              ? 'w-auto'
              : `flex flex-row max-[1200px]:justify-around max-[1200px]:items-center ${props?.className === 'reportIndividual_footer' ? '!p-0' : ''
              }`
            }`}
        >
          <div className="relative top-[2px] overflow-clip">{props.children}</div>
          <div
            className={`${props?.buttonType === 'reportIndividualButton'
                ? `relative h-[18px] text-white text-sm top-[2px] font-semibold hover:border-b-[1px] hover:border-solid hover:border-[#FF0808] max-[1200px]:text-[16px] max-[1200px]:bottom-[4px] max-[1200px]:top-[0px] max-[1200px]:hover:border-b-0 ${props.className === 'reportIndividualSidebar'
                  ? 'leading-[22.8571px]'
                  : 'leading-normal'
                }`
                : `font-bold text-inherit top-[4px] pt-[1px] ${props?.buttonType === 'footerDonateButton' ? 'text-[24px]' : 'text-[16px]'
                }`
              }`}
          >
            {' ' + props.buttonText}
          </div>
        </div>
      </Link>
    </div>
  ) : (
    <button
      className={`cursor-pointer rounded-[5px] flex items-center justify-center min-w-[96px] focus:outline-none max-[1200px]:w-[194px] hover:text-feYellow ${props?.buttonType === 'reportIndividualButton'
          ? 'py-[2px] px-[5px] bg-transparent'
          : ` py-[0px] px-[10px] bg-feYellow m-0 border-[3px] border-solid border-feYellow h-[34px] max-[1200px]:w-[135px] max-[1200px]:h-[34px] hover:bg-transparent ${props?.buttonType === 'footerDonateButton' &&
          'w-[147px] h-[48.72px] rounded-[8px] shadow-[0px 4px 4px rgba(0, 0, 0, 0.25)] text-[24px]'
          }`
        }`}
    >
      <div className="hover:text-inherit">
        {props.children}
        {props.buttonText}
      </div>
    </button>
  )
}

export default CMButton
